import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import manualHelper from 'views/App/Portal/Policy/_helpers/manualHelper';

import type { Manual } from '../../_types/manuals/draft';

export const getIssuedManual = async (id?: string) => {
  const url = `${baseApiUrl()}/lexipub/manuals/issued/v1/manuals/${id}`;
  const res = await fetcher({
    method: 'get',
    url,
  });
  const convertedManual = manualHelper.convertManual(res) as Manual;

  // Check for inline attachments in the manual content
  const checkContentForInlineAttachments = (content: string, title: string) => {
    if (content && content.includes('s3://')) {
      console.log(`Found inline attachment in section: ${title}`);
    }
  };

  // Check prefaces
  convertedManual.prefaces?.forEach((preface) => {
    checkContentForInlineAttachments(preface.content, `Preface: ${preface.title}`);
  });

  // Check chapters
  convertedManual.chapters?.forEach((chapter) => {
    // Check policies
    chapter.policies?.forEach((policy) => {
      // Check sections
      policy.sections?.forEach((section) => {
        checkContentForInlineAttachments(section.content, `${chapter.title} > ${policy.title} > ${section.title}`);

        // Check subsections
        section.subSections?.forEach((subsection) => {
          checkContentForInlineAttachments(
            subsection.content,
            `${chapter.title} > ${policy.title} > ${section.title} > ${subsection.title}`
          );
        });
      });
    });
  });

  return convertedManual;
};

export default function useIssuedManual(id?: string, options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<Manual, ServerErrorResponse>(
    ['issued_manual', id],
    async (): Promise<Manual> => {
      try {
        return await getIssuedManual(id);
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      keepPreviousData: false,
    }
  );
}
